module.exports = __webpack_public_path__ + "img/phone3.60be0c5d.png";